import React from 'react'
import { Link } from 'react-router-dom'

/** Карточка тикета пополнения: единственный маршрут, на который ведёт токен депозита. */
export const paymentTicketCardUrl = (token: string): string => '/payment-tickets/card/' + token

type Props = {
  /** Токен депозита. Пусто — прочерк, ссылки нет. */
  token?: string | null
  className?: string
  /** Что показать вместо пустого токена. */
  empty?: React.ReactNode
}

/**
 * Токен депозита в списках, отчётах и журналах: всегда ссылка на карточку этого тикета,
 * открывается в новой вкладке. Парный к `PayoutTokenLink` — у каждого типа тикета свой маршрут,
 * и одним компонентом они не рисуются.
 *
 * Клик не всплывает: токен часто стоит в строке-аккордеоне, и переход по ссылке не должен
 * сворачивать или раскрывать строку.
 */
export const DepositTokenLink: React.FC<Props> = ({ token, className, empty = '-' }) => {
  if (!token) return <>{empty}</>

  return (
    <Link
      to={paymentTicketCardUrl(token)}
      target='_blank'
      className={className ?? 'text-primary'}
      onClick={(e) => e.stopPropagation()}
    >
      {token}
    </Link>
  )
}

export default DepositTokenLink
